import { memo } from 'react';
import { CallCardPersonGrid } from '@/components/callcard/CallCardPersonGrid';
import { CallCardVehicleGrid } from '@/components/callcard/CallCardVehicleGrid';

interface CallCardPeopleVehiclesTabProps {
  people: any[];
  vehicles: any[];
  isReadOnly: boolean;
  onPeopleChange: (people: any[]) => void;
  onVehiclesChange: (vehicles: any[]) => void;
  onLinkPerson: (uuid: string) => void;
  onShowLinkedPerson: (npsdPersonId: number) => void;
  onCreateNpsdPerson: (uuid: string, personData: any) => void;
  onLinkVehicle: (uuid: string) => void;
  onShowLinkedVehicle: (npsdVehicleId: number) => void;
  onCreateNpsdVehicle: (uuid: string, vehicleData: any) => void;
}

export const CallCardPeopleVehiclesTab = memo(function CallCardPeopleVehiclesTab({
  people,
  vehicles,
  isReadOnly,
  onPeopleChange,
  onVehiclesChange,
  onLinkPerson,
  onShowLinkedPerson,
  onCreateNpsdPerson,
  onLinkVehicle,
  onShowLinkedVehicle,
  onCreateNpsdVehicle,
}: CallCardPeopleVehiclesTabProps) {
  return (
    <div className="tab-content-panel">
      <CallCardVehicleGrid
        vehicles={vehicles}
        isReadOnly={isReadOnly}
        onChange={onVehiclesChange}
        onLinkVehicle={onLinkVehicle}
        onShowLinkedVehicle={onShowLinkedVehicle}
        onCreateNpsdVehicle={onCreateNpsdVehicle}
      />
      <CallCardPersonGrid
        people={people}
        isReadOnly={isReadOnly}
        onChange={onPeopleChange}
        onLinkPerson={onLinkPerson}
        onShowLinkedPerson={onShowLinkedPerson}
        onCreateNpsdPerson={onCreateNpsdPerson}
      />
    </div>
  );
});
